<template>
  <v-card :loading="loading" class="col-md-12 mx-autos">
    <div>
      <v-btn
        @click="$router.replace({ name: 'submitForm' })"
        class="btn-add-with-text"
      >
        <span class="fa fa-plus ml-1"></span>
        افزودن
      </v-btn>
    </div>
    <mixed-table
      :data="data"
      :columns="columns"
      :fetch-data="getData"
      :reload-table="reloadTable"
    />
  </v-card>
</template>

<script>
import MixedTable from "@/view/components/Table/MixedTable";
import { debounce } from "@/main";
import button from "@/view/pages/button";

export default {
  name: "requestList",
  components: { MixedTable },
  data() {
    return {
      loading: false,
      priceDialog: false,
      isEditing: false,
      data: {},
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox" name="checkID"  data-id="${val.data.id}">`;
          },
        },
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
          primary: true,
        },
        {
          label: "حوزه فعالیت",
          name: "category",
          transform(val) {
            let workType = {
              lifeStyle: "لایف استایل ( سبک زندگی)",
              music: "موسیقی",
              "real-estate": "املاک و خانه",
              foodBlogger: "غذا (تستر و بلاگر غذا )",
              financial: "اقتصادی و مالی",
              investment: "سرمایه گذاری",
              technology: "تکنولوژی",
              winer: "طنز (واینر)",
              beautyBlogger: "بیوتی بلاگر",
              travelBlogger: "سفر و گردشگری",
              sportBlogger: "ورزش و سلامت",
              gaming: "گیمینگ (استریمر)",
              fashionBlogger: "مد و فشن",
              fitnessBlogger: "تناسب اندام (فیتنس بلاگر)",
              carBlogger: "ماشین",
              bookBlogger: "کتاب",
              individualDevelopment: "توسعه فردی",
              growth: "رشد",
              successWays: "راه‌های موفقیت",
              coach: "کوچ و کسب درآمد و بیزینسی",
              marketing: "بازاریابی (مارکتینگ)",
              education: "آموزشی",
            };
            return workType[val.data.category];
          },
          searchable: true,
        },
        {
          label: "آیدی اینستاگرام",
          name: "ig_id",
        },
        {
          label: "تاریخ ایجاد",
          name: "created_at",
          searchable: true,
        },
        {
          label: "مدیریت",
          name: "action",
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            buttons: [
              {
                name: "delete",
                label: "حذف صفحه",
                icon: "trash-alt",
                class: "btn-outline-danger",
                action: this.actions,
                condition: () => {
                  return true;
                },
              },
              // {
              //   name: 'Edit',
              //   label: 'ویرایش صفحه',
              //   icon: 'pencil-alt',
              //   class: 'btn-outline-warning',
              //   action: this.actions,
              //   condition: () => {
              //     return true;
              //   }
              // },
            ],
          },
        },
      ],
    };
  },
  methods: {
    getData(query = this.tableProps) {
      this.loading = true;

      this.$api
        .get("/business", {
          params: query,
        })
        .then((response) => {
          this.data = response.data.data;
        })
        .catch((reason) => {
          this.$modal.error("خطا", "در دریافت اطلاعات با خطا مواجه‌ شدیم.");

          console.log(reason.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getData(tableProps);
      }, 1000);
    },
    actions(data, type) {
      this[type + "Action"](data);
    },
    deleteAction(data) {
      this.$modal
        .yesNo("آیا از حذف این اطلاعات اطمینان دارید؟")
        .then((value) => {
          if (value === true) {
            this.loading = true;
            this.$api
              .delete(`/business/${data.id}`)
              .then(() => {
                this.loading = false;
                this.$toast.success("دیتای موردنظر شما با موفقیت حذف شد.");
                this.reloadTable();
              })
              .catch(() => {
                this.loading = false;
                this.$toast.error("خطا!");
              })
              .finally(() => {
                this.loading = false;
              });
          } else return false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped></style>
